// Enum mapping spirit names to their hash values
export enum ExoticClassItemSpirits {
  SpiritOfTheSwarm = 183430246,
  SpiritOfTheClaw = 183430247,
  SpiritOfTheStag = 183430248,
  SpiritOfStarfire = 183430249,
  SpiritOfApotheosis = 183430250,
  SpiritOfVesper = 183430251,
  SpiritOfTheNecrotic = 183430252,
  SpiritOfOsmiomancy = 183430253,
  SpiritOfHarmony = 183430254,
  SpiritOfTheFilaments = 183430255,
  SpiritOfCompetition = 302488496,
  SpiritOfTheAssassin = 1476923952,
  SpiritOfInmostLight = 1476923953,
  SpiritOfTheOphidian = 1476923954,
  SpiritOfTheStarEater = 1476923955,
  SpiritOfSynthoceps = 1476923956,
  SpiritOfVerity = 1476923957,
  SpiritOfTheArmamentarium = 3573490500,
  SpiritOfAlphaLupi = 3573490501,
  SpiritOfContact = 3573490504,
  SpiritOfTheBear = 3573490505,
  SpiritOfTheHorn = 3573490506,
  SpiritOfScars = 3573490507,
  SpiritOfHoarfrost = 3573490508,
  SpiritOfSeverance = 3573490509,
  SpiritOfTheAbeyant = 3573490510,
  SpiritOfTheEternalWarrior = 3573490511,
  SpiritOfTheCoyote = 3751917990,
  SpiritOfTheWormhusk = 3751917991,
  SpiritOfTheLiar = 3751917992,
  SpiritOfTheGyrfalcon = 3751917993,
  SpiritOfTheCyrtarachne = 3751917994,
  SpiritOfRenewal = 3751917995,
  SpiritOfCaliban = 3751917996,
  SpiritOfTheFoetracer = 3751917997,
  SpiritOfGalanor = 3751917998,
  SpiritOfTheDragon = 3751917999,
}

// Map of exotic class item perk hashes to their display names
export const ExoticClassItemPerkNames: Record<ExoticClassItemSpirits, string> = {
  [ExoticClassItemSpirits.SpiritOfTheSwarm]: "Spirit of the Swarm",
  [ExoticClassItemSpirits.SpiritOfTheClaw]: "Spirit of the Claw",
  [ExoticClassItemSpirits.SpiritOfTheStag]: "Spirit of the Stag",
  [ExoticClassItemSpirits.SpiritOfStarfire]: "Spirit of Starfire",
  [ExoticClassItemSpirits.SpiritOfApotheosis]: "Spirit of Apotheosis",
  [ExoticClassItemSpirits.SpiritOfVesper]: "Spirit of Vesper",
  [ExoticClassItemSpirits.SpiritOfTheNecrotic]: "Spirit of the Necrotic",
  [ExoticClassItemSpirits.SpiritOfOsmiomancy]: "Spirit of Osmiomancy",
  [ExoticClassItemSpirits.SpiritOfHarmony]: "Spirit of Harmony",
  [ExoticClassItemSpirits.SpiritOfTheFilaments]: "Spirit of the Filaments",
  [ExoticClassItemSpirits.SpiritOfCompetition]: "Spirit of Competition",
  [ExoticClassItemSpirits.SpiritOfTheAssassin]: "Spirit of the Assassin",
  [ExoticClassItemSpirits.SpiritOfInmostLight]: "Spirit of Inmost Light",
  [ExoticClassItemSpirits.SpiritOfTheOphidian]: "Spirit of the Ophidian",
  [ExoticClassItemSpirits.SpiritOfTheStarEater]: "Spirit of the Star-Eater",
  [ExoticClassItemSpirits.SpiritOfSynthoceps]: "Spirit of Synthoceps",
  [ExoticClassItemSpirits.SpiritOfVerity]: "Spirit of Verity",
  [ExoticClassItemSpirits.SpiritOfTheArmamentarium]: "Spirit of the Armamentarium",
  [ExoticClassItemSpirits.SpiritOfAlphaLupi]: "Spirit of Alpha Lupi",
  [ExoticClassItemSpirits.SpiritOfContact]: "Spirit of Contact",
  [ExoticClassItemSpirits.SpiritOfTheBear]: "Spirit of the Bear",
  [ExoticClassItemSpirits.SpiritOfTheHorn]: "Spirit of the Horn",
  [ExoticClassItemSpirits.SpiritOfScars]: "Spirit of Scars",
  [ExoticClassItemSpirits.SpiritOfHoarfrost]: "Spirit of Hoarfrost",
  [ExoticClassItemSpirits.SpiritOfSeverance]: "Spirit of Severance",
  [ExoticClassItemSpirits.SpiritOfTheAbeyant]: "Spirit of the Abeyant",
  [ExoticClassItemSpirits.SpiritOfTheEternalWarrior]: "Spirit of the Eternal Warrior",
  [ExoticClassItemSpirits.SpiritOfTheCoyote]: "Spirit of the Coyote",
  [ExoticClassItemSpirits.SpiritOfTheWormhusk]: "Spirit of the Wormhusk",
  [ExoticClassItemSpirits.SpiritOfTheLiar]: "Spirit of the Liar",
  [ExoticClassItemSpirits.SpiritOfTheGyrfalcon]: "Spirit of the Gyrfalcon",
  [ExoticClassItemSpirits.SpiritOfTheCyrtarachne]: "Spirit of the Cyrtarachne",
  [ExoticClassItemSpirits.SpiritOfRenewal]: "Spirit of Renewal",
  [ExoticClassItemSpirits.SpiritOfCaliban]: "Spirit of Caliban",
  [ExoticClassItemSpirits.SpiritOfTheFoetracer]: "Spirit of the Foetracer",
  [ExoticClassItemSpirits.SpiritOfGalanor]: "Spirit of Galanor",
  [ExoticClassItemSpirits.SpiritOfTheDragon]: "Spirit of the Dragon",
};
